// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SbDKL2bctOyC5ZgA0KfW {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 3vmin;
  padding: 2vmin;
  color: var(--text-light);
  background-color: var(--white);
  border: 0.2vmin solid var(--tan-3);
  border-radius: 1vmin;
  font-size: 3vmin;
  cursor: pointer;
  transition: transform 0.4s, box-shadow 0.4s;
}

.SbDKL2bctOyC5ZgA0KfW > div > div:first-child {
  margin-bottom: 0.5vmin;
}

.SbDKL2bctOyC5ZgA0KfW.mOA_Z5p05rn7VW_2oU68 {
  box-shadow: 0 0 10px rgba(2, 62, 14, 0.5);
  border-color: var(--green-yellow);
  border-width: 0.2vmin;
  transform: scale(1.08);
  cursor: default;
}

.SbDKL2bctOyC5ZgA0KfW:not(.mOA_Z5p05rn7VW_2oU68):hover {
  transform: scale(1.08);
  box-shadow: 0 0 10px rgba(0, 0, 128, 0.5);
}`, "",{"version":3,"sources":["webpack://./src/components/OrderListItem/OrderListItem.module.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,oBAAA;EACA,cAAA;EACA,wBAAA;EACA,8BAAA;EACA,kCAAA;EACA,oBAAA;EACA,gBAAA;EACA,eAAA;EACA,2CAAA;AACJ;;AAEA;EACI,sBAAA;AACJ;;AAEA;EACI,yCAAA;EACA,iCAAA;EACA,qBAAA;EACA,sBAAA;EACA,eAAA;AACJ;;AAEA;EACI,sBAAA;EACA,yCAAA;AACJ","sourcesContent":[".OrderListItem {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 3vmin;\n    padding: 2vmin;\n    color: var(--text-light);\n    background-color: var(--white);\n    border: .2vmin solid var(--tan-3);\n    border-radius: 1vmin;\n    font-size: 3vmin;\n    cursor: pointer;\n    transition: transform 0.4s, box-shadow 0.4s;\n}\n\n.OrderListItem>div>div:first-child {\n    margin-bottom: .5vmin;\n}\n\n.OrderListItem.selected {\n    box-shadow: 0 0 10px rgba(2, 62, 14, 0.5);\n    border-color: var(--green-yellow);\n    border-width: .2vmin;\n    transform: scale(1.08);\n    cursor: default;\n}\n\n.OrderListItem:not(.selected):hover {\n    transform: scale(1.08);\n    box-shadow: 0 0 10px rgba(0, 0, 128, 0.5);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"OrderListItem": `SbDKL2bctOyC5ZgA0KfW`,
	"selected": `mOA_Z5p05rn7VW_2oU68`
};
export default ___CSS_LOADER_EXPORT___;
